module.exports = __webpack_public_path__ + "static/media/banner-home.04d9f2e9.png";